// Read-only presale reports. Amounts are proposals, never received revenue.
// Server-authorized queue is the sole input. Never trust this for settlement.
export const PRESALE_COMPANIES=[
 {id:'aa40691b-a6bf-4622-8c51-a515e2345005',name:'Casa da Limpeza'},
 {id:'c4ed5f2b-ff91-4f3b-ba0f-1b40ce585e5b',name:'ConsertCell'}
];
const companies=new Map(PRESALE_COMPANIES.map(o=>[o.id,o.name]));
export const PRESALE_STATUS={
 draft:'Rascunho',pending_confirmation:'A confirmar',
 approved_for_checkout:'Aguardando confirmação externa',
 converted:'Encaminhada para registro externo',
 cancelled:'Cancelada'
};
const cleanCents=v=>Number.isSafeInteger(v)&&v>=0&&v<=9000000000000;
const inputDate=v=>/^\d{4}-\d{2}-\d{2}$/.test(v||'')?v:null;
export const presaleDate=(iso)=>{
 const date=new Date(iso||'');
 if(!Number.isFinite(date.getTime()))return null;
 const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Sao_Paulo',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(date);
 const x=Object.fromEntries(parts.map(x=>[x.type,x.value]));
 return x.year+'-'+x.month+'-'+x.day;
};
export function reportDateRange(now=new Date()){
 const day=presaleDate(now);
 if(!day)throw Error('invalid_report_clock');
 return {start:day.slice(0,8)+'01',end:day};
}
export function calculatePresaleReport(presales=[],{org='all',status='all',start='',end='',term='',completeSource=false}={}){
 if(!Array.isArray(presales))throw Error('invalid_presale_report_data');
 if(org!=='all'&&!companies.has(org))throw Error('invalid_report_organization');
 if(status!=='all'&&!Object.hasOwn(PRESALE_STATUS,status))throw Error('invalid_report_status');
 const from=inputDate(start),to=inputDate(end);
 if((start&&!from)||(end&&!to)||(from&&to&&from>to))throw Error('invalid_report_dates');
 const q=String(term||'').trim().toLocaleLowerCase('pt-BR');
 const rows=[],byCompany=PRESALE_COMPANIES.map(o=>({...o,count:0,total_cents:0}));
 const byStatus={},byDate={};let total_cents=0;
 for(const p of presales){
  if(!p||typeof p!=='object'||!Array.isArray(p.sellers)||
     !Object.hasOwn(PRESALE_STATUS,p.status)||!cleanCents(Number(p.total_cents)))throw Error('invalid_report_row');
  const date=presaleDate(p.created_at);
  if(!date)throw Error('invalid_presale_date');
  if((from&&date<from)||(to&&date>to)||(status!=='all'&&p.status!==status))continue;
  const sellers=p.sellers.map(s=>{
    if(!companies.has(s.organization_id)||!cleanCents(Number(s.subtotal_cents)))throw Error('invalid_report_seller');
    return {organization_id:s.organization_id,company:companies.get(s.organization_id),subtotal_cents:Number(s.subtotal_cents)};
  });
  if(!sellers.length||new Set(sellers.map(s=>s.organization_id)).size!==sellers.length||
    sellers.reduce((n,s)=>n+s.subtotal_cents,0)!==Number(p.total_cents))throw Error('report_amount_mismatch');
  const shown=org==='all'?sellers:sellers.filter(s=>s.organization_id===org);
  if(!shown.length)continue;
  const id=String(p.display_number||p.presale_key||p.id||'');
  if(q&&!id.toLocaleLowerCase('pt-BR').includes(q))continue;
  const subtotal=shown.reduce((n,s)=>n+s.subtotal_cents,0);
  rows.push({id:String(p.id||''),number:id,date,created_at:p.created_at,status:p.status,status_label:PRESALE_STATUS[p.status],sellers:shown,total_cents:subtotal});
  // Cancelled and already-converted proposals remain in the history but do
  // not inflate the active forecast. Neither state confirms payment.
  const activeForecast=!['cancelled','converted'].includes(p.status);
  if(activeForecast)total_cents+=subtotal;
  if(!cleanCents(total_cents))throw Error('report_amount_overflow');
  byStatus[p.status]=(byStatus[p.status]||0)+1;
  byDate[date]??={date,count:0,total_cents:0};
  byDate[date].count+=1;byDate[date].total_cents+=activeForecast?subtotal:0;
  for(const seller of shown){
   const target=byCompany.find(c=>c.id===seller.organization_id);
   target.count+=1;target.total_cents+=activeForecast?seller.subtotal_cents:0;
  }
 }
 rows.sort((a,b)=>b.created_at.localeCompare(a.created_at));
 return {rows,total_cents,count:rows.length,byCompany,byStatus,byDate:Object.values(byDate).sort((a,b)=>b.date.localeCompare(a.date)),source_count:presales.length,
  truncated:!completeSource&&presales.length>=50,partial:!completeSource&&presales.length>=50};
}
const safeCsv=v=>{
 let txt=String(v??'').replace(/[\r\n\t]+/g,' ').trim();
 if(/^[\s]*[=+@\-]/.test(txt))txt="'"+txt;
 return '"'+txt.replace(/"/g,'""')+'"';
};
export function reportCsv(report){
 const lines=[['Pré-venda','Data (America/Sao_Paulo)','Situação','Empresa','Valor previsto (R$)','Documento fiscal?','Pagamento confirmado?']];
 for(const p of report.rows)for(const s of p.sellers)lines.push([
  p.number,p.date,p.status_label,s.company,(s.subtotal_cents/100).toFixed(2).replace('.',','),'Não','Não'
 ]);
 return '\uFEFF'+lines.map(r=>r.map(safeCsv).join(';')).join('\r\n')+'\r\n';
}
